var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelopeRobotOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    viewBox: "0 0 128 128",
    id: "envelope-robot",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_2191)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#ff4d4f",
    strokeWidth: 8,
    d: "M106.5 31.5L96.5269 41.4731C81.1936 56.8064 73.5269 64.4731 64 64.4731C54.4731 64.4731 46.8064 56.8064 31.4731 41.4731L21.5 31.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff4d4f",
    strokeLinecap: "round",
    strokeWidth: 8,
    d: "M112 71V70C112 48.3154 112 37.4731 105.263 30.7365 98.5269 24 87.6846 24 66 24H56C40.0867 24 32.1301 24 26.3856 27.7678 23.7494 29.4969 21.4969 31.7494 19.7678 34.3856 16 40.1301 16 48.0867 16 64V64C16 79.9133 16 87.8699 19.7678 93.6144 21.4969 96.2506 23.7494 98.5031 26.3856 100.232 32.1301 104 40.0867 104 56 104H64M89 96L89 94M100 96L100 94M94 83L94 78"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 22,
    x: 79,
    y: 84,
    stroke: "#ff4d4f",
    strokeWidth: 8,
    rx: 9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_2191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeRobotOff);
export default __webpack_public_path__ + "static/media/envelope-robot-off.efba9867989fdb5efe52538925f75a54.svg";
export { ForwardRef as ReactComponent };